import { render } from "./AcceptProtocol.vue?vue&type=template&id=27494590&scoped=true&ts=true"
import script from "./AcceptProtocol.vue?vue&type=script&lang=ts"
export * from "./AcceptProtocol.vue?vue&type=script&lang=ts"

import "./AcceptProtocol.vue?vue&type=style&index=0&id=27494590&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27494590"]])